module.exports = __webpack_public_path__ + "static/media/Jakiro.1f262b77.png";